import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IAddDocumentInterventionRequestAction {
  data: {
    document: File;
    file_type: string;
    id: number;
    invoiceNumber: string;
    price: number;
    vat: string;
  };
  functions: {
    close: () => void;
    success: () => void;
    error: (err: any) => void;
  };
}

function addDocumentRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IAddDocumentInterventionRequestAction>,
) {
  draft.addDocument.config.isLoading = true;
}

export default addDocumentRequest;
